<template>
  <div
    v-if="date"
    class="base-timestamp"
  >
    <or-tooltip
      v-if="useTooltip"
      v-model="isTooltipShown"
      :content="tooltipText"
    >
      <span class="text">
        {{ content }}
      </span>
    </or-tooltip>

    <span
      v-else
      class="text"
    >
      {{ content }}
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from '@vue/composition-api';
import { OrTooltipV3 as OrTooltip } from '@onereach/ui-components-25';
import { format, isToday } from 'date-fns';

export default defineComponent({
  name: 'BaseTimestamp',
  components: {
    OrTooltip,
  },
  props: {
    date: {
      type: [Number, String, Date],
      required: true,
    },
    format: {
      type: String,
      default: '',
    },
    useTooltip: {
      type: Boolean,
    },
  },
  setup() {
    const isTooltipShown = ref(false);

    return {
      SHORT_TIME_FORMAT: 'h:mm a',
      SHORT_FULL_TIME_FORMAT: 'HH:mm:ss',
      DATE_TIME_FORMAT: 'MMM dd yyyy, h:mm a',
      isTooltipShown,
    };
  },
  computed: {
    content(): string {
      const date = new Date(this.date);
      const dateFormat = this.format
        ? this.format
        : isToday(date)
          ? this.SHORT_FULL_TIME_FORMAT
          : this.DATE_TIME_FORMAT;

      return format(date, dateFormat);
    },

    tooltipText(): string {
      return format(new Date(this.date), this.DATE_TIME_FORMAT);
    },
  },
});
</script>
